var map = {
	"./Kitemill om sikker energiforsyning og bærekraft.png": "fb16",
	"./NorCod med i TERRAVERA Business Program.png": "7b96",
	"./OPUS blir en del av TERRAVERA Business Program.png": "5e95",
	"./ScaleAQ - ny deltaker i TERRAVERA Business Program.png": "a523",
	"./default.png": "384c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a312";